import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from 'react-redux';
import { addRole, getRoles } from '../../reducers/commonReducer';

const schema = yup.object().shape({
    name: yup.string().required(),
    status: yup.boolean().required(),
  });

function RoleAdd(props) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Add New Role
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Role</Modal.Title>
        </Modal.Header>
        <Formik
                validationSchema={schema}
                onSubmit={async (values, { resetForm }) => {
                    await dispatch(addRole(values))
                    resetForm({ values: "" });
                    dispatch(getRoles());
                }}
                initialValues={{
                  name: "",
                  status: "",
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  setFieldValue,
                  errors,
                }) => (
                  <Form className='container' onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            isInvalid={!!errors.name}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                              as="select"
                              controlId="validationFormik03"
                              onChange={async (e) => {
                                setFieldValue("status", e.target.value);
                              }}
                              name="status"
                              className="form-control"
                              value={values.status}
                              isInvalid={!!errors.status}
                            >
                              <option value="">Select Status</option>
                              <option value={true}>True</option>
                              <option value={false}>False</option>
                            </Form.Control>
                      </Col>
                    </Row>
                    <Modal.Footer>
                        <Button variant="success" type="submit">Submit</Button>
                        <Button variant="danger" onClick={handleClose}>Close</Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
      </Modal>
    </>
  );
}

export default RoleAdd;